/**
 * Client Supabase pour le frontend.
 * Utilise l'anon key + JWT Clerk pour respecter les policies RLS.
 *
 * IMPORTANT : aucun secret service_role côté client.
 * Toute opération sensible passe par le backend paja-agent via /api/*.
 */
import { createClient, SupabaseClient } from '@supabase/supabase-js';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase env vars');
}

// Le schema 'paja' est non-public donc le SupabaseClient générique typé
// 'public' est incompatible. On stocke en `any` puis on cast au retour.
let _client: unknown = null;

/**
 * Retourne un client Supabase configuré pour lire le schema `paja`.
 * Pour Ducens tables (public.*), utiliser supabasePublic().
 */
export function supabasePaja(getToken?: () => Promise<string | null>): SupabaseClient {
  if (!_client) {
    _client = createClient(SUPABASE_URL!, SUPABASE_ANON_KEY!, {
      db: { schema: 'paja' },
      auth: { persistSession: false, autoRefreshToken: false },
      global: getToken
        ? {
            fetch: async (input, init) => {
              const token = await getToken();
              const headers = new Headers(init?.headers);
              if (token) headers.set('Authorization', `Bearer ${token}`);
              return fetch(input, { ...init, headers });
            },
          }
        : {},
    });
  }
  return _client as SupabaseClient;
}

let _publicClient: SupabaseClient | null = null;

export function supabasePublic(getToken?: () => Promise<string | null>): SupabaseClient {
  if (!_publicClient) {
    _publicClient = createClient(SUPABASE_URL!, SUPABASE_ANON_KEY!, {
      auth: { persistSession: false, autoRefreshToken: false },
      global: getToken
        ? {
            fetch: async (input, init) => {
              const token = await getToken();
              const headers = new Headers(init?.headers);
              if (token) headers.set('Authorization', `Bearer ${token}`);
              return fetch(input, { ...init, headers });
            },
          }
        : {},
    });
  }
  return _publicClient!;
}
